import { injectable } from "tsyringe";
import { DutyTaxConfigurationApiRepository } from "@/app/infrastructures/repositories/api/DutyTaxConfigurationApiRepository";
import {
  DutyTaxConfigurationListFilter,
  DutyTaxConfigurationListResult,
  DutyTaxResolveParams,
  DutyTaxResolveResult
} from "@/domain/entities/DutyTaxConfiguration";

@injectable()
export class DutyTaxConfigurationPresenter {
  private repository: DutyTaxConfigurationApiRepository;

  constructor(repository: DutyTaxConfigurationApiRepository) {
    this.repository = repository;
  }

  getList(
    params: DutyTaxConfigurationListFilter
  ): Promise<DutyTaxConfigurationListResult> {
    return this.repository.getList(params);
  }

  resolve(params: DutyTaxResolveParams): Promise<DutyTaxResolveResult | null> {
    return this.repository.resolve(params);
  }
}
